import { ActionType } from './general';

export interface CommonTableAction {
  item: any;
  index: number;
  type: ActionType;
}
